import { render, staticRenderFns } from "./AdminOrgCommittee.vue?vue&type=template&id=38836e18&scoped=true&"
import script from "./AdminOrgCommittee.vue?vue&type=script&lang=js&"
export * from "./AdminOrgCommittee.vue?vue&type=script&lang=js&"
import style0 from "./AdminOrgCommittee.vue?vue&type=style&index=0&id=38836e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38836e18",
  null
  
)

export default component.exports